import _ from 'lodash';

import * as graphql from '@treams/treams-network';

import { onGrowthPathScale } from '../growth-path/GrowthPathConverter';
import { GrowthPathScale } from '../growth-path/hooks/useGrowthPathScale';

export interface ISkillsAnalysis {
	jobTitle?: graphql.JobTitle;
	appraisals: graphql.CompetencyAppraisal[];
	competencies: graphql.Competency[];
	jobCompetencies: graphql.JobCompetency[];
}

export function isOwnedJobTitle(user: graphql.User, jobTitleID: string) {
	if (jobTitleID === 'all') {
		return true;
	}

	const { jobPositions } = user;
	const result = jobPositions.find((jobPosition) => {
		return jobPosition.jobTitle.id === jobTitleID;
	});

	return !!result;
}

export function skillsAnalysisFromUser(
	user: graphql.User,
	jobTitleID: string | undefined,
	scale: GrowthPathScale | undefined,
): ISkillsAnalysis {
	const { jobPositions } = user;
	const selectedPositions = jobPositions.filter((jobPosition) => {
		if (!jobTitleID || jobTitleID === 'all') {
			return true;
		}
		return jobPosition.jobTitle.id === jobTitleID;
	});

	const jobCompetencies = selectedPositions.flatMap(({ competencies }) =>
		onGrowthPathScale(competencies, scale),
	) as graphql.JobCompetency[];

	const appraisals = selectedPositions.flatMap(
		({ appraisal }) => appraisal,
	) as graphql.CompetencyAppraisal[];

	const competencies = _.uniqBy(
		_.map(jobCompetencies, ({ competency }) => competency),
		'id',
	);

	return {
		appraisals,
		competencies,
		jobCompetencies,
		jobTitle: jobTitleID
			? jobPositions.find((jobPosition) => {
					return jobPosition.jobTitle.id === jobTitleID;
				})?.jobTitle
			: undefined,
	};
}

export function skillsAnalysisFromJobTitle(
	jobTitle: graphql.JobTitle,
	scale: GrowthPathScale | undefined,
): ISkillsAnalysis {
	const jobCompetencies = onGrowthPathScale(jobTitle.competencies, scale);
	const appraisals = jobTitle.appraisal;
	const competencies = _.uniqBy(
		_.map(jobCompetencies, ({ competency }) => competency),
		'id',
	);

	return { appraisals, competencies, jobCompetencies, jobTitle };
}
